import {
  Button,
  Grid,
  Box,
  
  
  
  Typography
} from '@mui/material'
import { makeStyles, createStyles } from '@mui/styles'

import React, { Fragment, useState } from 'react'

import { NewPickingRouteHeader } from './NewPickingRouteHeader'

import {
  PickingInputData,
  PickingRoute,
  PickingRouteDetails,
  Position,
  StockKeepingUnit
} from '../../../interfaces/Picking/Picking'

import { PickingProductForm } from './PickingProductForm'

import { PickingRouteProductInfo } from './PickingRouteProductInfo'

import { PickingRouteContext } from '../../../components/Picking/PickingRouteContext'

import { EnumPickingStep } from '../pickingConfig'

import useMediaQuery from '@mui/material/useMediaQuery'

import { useTheme, Theme } from '@mui/material/styles'

import { Modal } from '../../../components/_EOS/Modal'
import { useModal } from '../../../hooks/useModal'

interface PickingProductDiffProps {
  pickingRoute?: PickingRoute
  pickingRouteDetails?: PickingRouteDetails
  handlePickUp: (inputData: PickingInputData) => void
  handleSkip: () => void
  handleOutOfStock: () => void
  configPickingRoutePositionScan: boolean
}

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    bottomBar: {
      backgroundColor: theme.palette.primary.main,
      position: 'absolute',
      bottom: '0px',
      right: '0px',
      height: 40,
      width: '100%',
      verticalAlign: 'middle'
    }
  })
)

export const PickingProductDiff: React.FC<PickingProductDiffProps> = ({
  pickingRoute,
  pickingRouteDetails,
  handlePickUp,
  handleSkip,
  handleOutOfStock,
  configPickingRoutePositionScan
}) => {
  const {
    size,
    isOpen,
    title,
    openModal: openModalDialog,
    closeModal: closeModalDialog
  } = useModal('Aviso!')
  const { setStep } = React.useContext(PickingRouteContext)

  const classes = useStyles()

  const theme = useTheme()

  const matches = useMediaQuery(theme.breakpoints.down('sm'))

  const details: PickingRouteDetails =
    pickingRouteDetails || new PickingRouteDetails()
  const product: StockKeepingUnit =
    pickingRouteDetails?.product || new StockKeepingUnit()
  const position: Position = pickingRouteDetails?.position || new Position()
  const pendingQuantity = details.realQuantity - details.pickedQuantity
  const dunPacksQty =
    details.product?.dunQty &&
    Math.floor(pendingQuantity / details.product.dunQty)
  const dunUnitsQty =
    details.product?.dunQty && pendingQuantity % details.product.dunQty
  const initialInput: PickingInputData = {
    sku: '',
    quantity: pendingQuantity,
    positionName: ''
  }

  const handleFormSubmit = (inputData: PickingInputData) => {
    handlePickUp(inputData)
  }

  const handleGoBack = () => {
    setStep(EnumPickingStep.ViewPickingProduct)
  }
  const [messageDialogAlert, setMessageDialogAlert] = useState<string>('')
  const handlerOpenAndCloseDialogAlert = (
    showSeconds: number = 3,
    message: string = ''
  ) => {
    setMessageDialogAlert(message)
    openModalDialog()

    setTimeout(() => {
      closeModalDialog()
    }, showSeconds * 1000)
  }

  const [statePositionsScaned, setStatePositionsScaned] = useState<string[]>([])

  return (
    <Fragment>
      <Box
        display='flex'
        flex='1'
        flexDirection='column'
        justifyContent='space-around'
      >
        <NewPickingRouteHeader
          pickingRoute={pickingRoute}
          position={position.positionName}
        />

        <PickingRouteProductInfo
          sku={product.sku}
          ean={product.ean13}
          qty={pendingQuantity}
          dunPacksQty={dunPacksQty}
          dunUnitsQty={dunUnitsQty}
          name={product.name}
          batchNumber={product.batchNumber}
          expirationDate={product.expirationDate}
        />

        <Grid
          container
          item
          xs={12}
          justifyContent='center'
          alignItems='center'
        >
          <PickingProductForm
            pickingRouteDetails={pickingRouteDetails}
            initialInputData={initialInput}
            isInputQuantity={true}
            handleFormSubmit={handleFormSubmit}
            handlerOpenAndCloseDialogAlert={handlerOpenAndCloseDialogAlert}
            statePositionsScaned={statePositionsScaned}
            setStatePositionsScaned={setStatePositionsScaned}
            configPickingRoutePositionScan={configPickingRoutePositionScan}
          />
        </Grid>

        <Grid
          container
          spacing={5}
          direction='column'
          alignItems='center'
          justifyContent='center'
        >
          <Grid container item xs={12} spacing={2}>
            <Grid item xs={6}>
              <Button
                variant='contained'
                color='secondary'
                onClick={handleOutOfStock}
                size='small'
                fullWidth
              >
                Sin unidades
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                variant='contained'
                color='primary'
                onClick={handleSkip}
                size='small'
                fullWidth
              >
                Saltar Posición
              </Button>
            </Grid>
            {!matches && (
              <Grid item xs={12}>
                <Button
                  variant='contained'
                  color='inherit'
                  onClick={handleGoBack}
                  size='small'
                  fullWidth
                >
                  Volver
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Box>
      {matches && (
        <Box mt={3} className={`${classes.bottomBar}`}>
          <Button style={{ color: 'white' }} onClick={handleGoBack}>
            {'< Volver'}
          </Button>
        </Box>
      )}
      <Modal
        open={isOpen}
        title={title}
        onClose={closeModalDialog}
        maxWidth={size}
      >
        <Typography variant='body1' style={{ color: 'red' }}>
          {messageDialogAlert}
        </Typography>
      </Modal>
    </Fragment>
  )
}
